import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Upload} from "antd";
import { firestore, storage } from "../../config/firebase";
import { UploadOutlined } from "@ant-design/icons";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import {
  collection,
  addDoc,
  updateDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";

const AdvertisementModal = ({ isOpen, onClose, selectedAdvertisement }) => {
  const [form] = Form.useForm();
  const [image, setImage] = useState({ currentImg: "", newImg: "" });
  useEffect(() => {
    form.resetFields();
    if (selectedAdvertisement) {
      form.setFieldsValue({
        title: selectedAdvertisement.title,
        description: selectedAdvertisement.description,
        rating: selectedAdvertisement.rating,
        link: selectedAdvertisement.link,
      });
      setImage({ ...image, currentImg: selectedAdvertisement.logo });
    } else {
    }
  }, [selectedAdvertisement, form]);

  const handleSave = async () => {
    let errors = form.getFieldsError();
    errors = errors
      .filter((el) => el.errors.length > 0)
      .map((el) => el.errors[0]);
    console.log("Error 0-00000000000000", errors);
    if (errors.length > 0) return;

    try {
      let imgUrl;
      if (image.newImg && image.currentImg) {
        const oldImageRef = ref(storage, `${image.currentImg}`);
        await deleteObject(oldImageRef);
        const uniqueFilename = `${Date.now()}-${uuidv4()}`;
        const storageRef = ref(storage, `AdvtImages/${uniqueFilename}`);
        await uploadBytes(storageRef, image.newImg);
        imgUrl = await getDownloadURL(storageRef);
      } else if (image.newImg && !image.currentImg) {
        const uniqueFilename = `${Date.now()}-${uuidv4()}`;
        const storageRef = ref(storage, `AdvtImages/${uniqueFilename}`);
        await uploadBytes(storageRef, image.newImg);
        imgUrl = await getDownloadURL(storageRef);
      }
      const values = await form.validateFields();
      const advertisement = {
        title: values.title,
        description: values.description,
        timestamp: serverTimestamp(),
        rating: values.rating,
        link: values.link,
        logo: imgUrl || image.currentImg,
      };

      if (selectedAdvertisement) {
        await updateDoc(
          doc(
            collection(firestore, "advertisements"),
            selectedAdvertisement.id
          ),
          advertisement
        );
      } else {
        await addDoc(collection(firestore, "advertisements"), advertisement);
      }
      onClose();
      window.location.reload();
    } catch (error) {
      console.error("Error saving advertisement:", error);
    }
  };

  const handleLogoChange = async (info) => {
    const { fileList } = info;
    const uploadedImages = fileList.map((file) => file.originFileObj);
    let ext = uploadedImages[0]?.name;
    ext = ext?.split(".");
    if (ext?.length > 0) {
      if (ext[1] == "svg") {
        form.setFields([
          {
            name: "image", // required
            errors: ["SVG image is not allowed"],
          },
        ]);
        return;
      } else {
        form.setFields([
          {
            name: "image", // required
            errors: [],
          },
        ]);
      }
    } else {
      form.setFields([
        {
          name: "image", // required
          errors: [],
        },
      ]);
    }
    setImage({ ...image, newImg: uploadedImages[0] });
  };
  return (
    <div>
       <Modal
      title={"Edit Advertisement"}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      getContainer={false}
    >
      <Form form={form} onFinish={handleSave}>
        <Form.Item label="Logo" name={"image"}>
          <Upload
            onChange={handleLogoChange}
            beforeUpload={() => false}
            maxCount={1}
          >
            <Button icon={<UploadOutlined />}>Upload Images</Button>
          </Upload>
        </Form.Item>

        <Form.Item label="Title" name="title" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: true }]}
        >
          <Input.TextArea />
        </Form.Item>
        <Form.Item label="Rating" name="rating" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Link" name="link" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
    </Modal>
    </div>
   
  );
};

export default AdvertisementModal;
